import './style.scss';

import initializeBundlesUI from "./bundles-ui.js";
import initializeAttendeeDropdowns from "./attendee-dropdowns.js";
import eventBus from "./events.js";
import Filters from "./filters.js";
import {context} from "./festival-context.ts"

window.festivalContext = context;

jQuery(function ($) {

    let config = {is_festival_page: false};


    if (typeof FestivalConfig !== 'undefined') {
        config = FestivalConfig;
    }

    if (config.is_festival_page) {
        initializeFestivalPage();
    }

    initializeAttendeeDropdowns();

    /*
    * WooCommerce caches response fragments internally, so we need to do the same to know
    * when the requests have finished and the page would have been updated.
    */
    let responseFragmentsCache = {};
    $.ajaxSetup({
        beforeSend(jqXHR, settings) {
            const success = settings.success;
            settings.success = function (data, textStatus, jqXHR) {
                data = Filters.apply('ajax_response', data, textStatus, jqXHR);
                if (success) {
                    success(data, textStatus, jqXHR);

                    if (data.fragments) {
                        responseFragmentsCache = data.fragments;
                    }
                }
            };
        }
    });

    function testXhrRequestIsCartUpdate(url, data) {
        return /action=(pp_update_add_in_cart|pp_add_to_cart|pp_remove_from_cart)/.test(data);
    }

    function testXhrRequestIsRefresh(url, data) {
        return /update_order_review|get_refreshed_fragments/.test(url);
    }

    function observeAndTriggerOnce(targetNode, eventName, args) {
        if (!targetNode) return;

        const observer = new MutationObserver(function (mutations) {
            eventBus.trigger(eventName, args);
            observer.disconnect();
        });

        observer.observe(targetNode, {childList: true, subtree: true});
    }

    function observeAttendeesReload() {
        const observerTarget = $('#fooevents_order_notes_page_load').parent();
        const observer = new MutationObserver(function (mutations) {
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {
                    for (let node of mutation.addedNodes) {
                        if (node.id === 'fooevents_order_notes_page_load') {
                            eventBus.trigger('attendees_reload');
                        }
                    }
                }
            }
        });

        if (observerTarget.length > 0) {
            observer.observe(observerTarget[0], {childList: true, subtree: true});
        }
    }

    observeAttendeesReload();

    /* Check to see if we are expecting new attendee data from the server and if not, remove the updating class to avoid it getting stuck. */
    Filters.add('ajax_response', function (data) {
        const matchesCache = data.fragments && data.fragments['#fooevents_order_notes_page_load'] === responseFragmentsCache['#fooevents_order_notes_page_load'];
        if ((!data.fragments || !data.fragments['#fooevents_order_notes_page_load']) && data.result === 'failure'
            || matchesCache) {
            // Clear the attendees updating styling.
            $('.fooevents-attendee--updating').removeClass('fooevents-attendee--updating');
        }

        return data;
    });

    /**
     * Keep track of when the cart/order is refreshed through Ajax.
     */

        // 7.5.0+ uses fetch
    const originalFetch = window.fetch;
    window.fetch = function (url, options) {
        const promise = originalFetch(url, options);
        const observerTarget = $('.woocommerce-checkout-review-order-table');
        if (testXhrRequestIsCartUpdate(url, options)) {
            eventBus.trigger('cart_change:start', arguments);
            observeAndTriggerOnce(observerTarget[0], 'cart_change:stop', arguments);
        }

        if (testXhrRequestIsRefresh(url, options)) {
            eventBus.trigger('refresh_order:start', arguments);
            observeAndTriggerOnce(observerTarget[0], 'refresh_order:stop', arguments);
        }
        return promise;
    };

    // 7.4.0 and below uses jQuery
    $(document).ajaxSend(function (e, xhr, options) {
        if (options.url) {
            if (testXhrRequestIsCartUpdate(options.url, options.data || '')) {
                eventBus.trigger('cart_change:start', arguments);
            }

            if (testXhrRequestIsRefresh(options.url, options.data || '')) {
                eventBus.trigger('refresh_order:start', arguments);
            }
        }
    }).ajaxComplete(function (e, xhr, options) {
        if (options.url && testXhrRequestIsCartUpdate(options.url, options.data || '')) {
            const observerTarget = $('.woocommerce-checkout-review-order-table');
            if (testXhrRequestIsCartUpdate(options.url, options.data || '')) {
                observeAndTriggerOnce(observerTarget[0], 'cart_change:stop', arguments);
            }

            if (testXhrRequestIsRefresh(options.url, options.data || '')) {
                observeAndTriggerOnce(observerTarget[0], 'refresh_order:stop', arguments);
            }
        }
    });

    eventBus.on('refresh_order:start', function () {
        $('body').addClass('woocommerce-updating-order-review');
    }).on('refresh_order:stop', function () {
        $('body').removeClass('woocommerce-updating-order-review');
    });

    function initializeFestivalPage() {

        initializeBundlesUI();

        $('#opc-messages').appendTo('body');

        $('.frCategory__header').on('click', function () {
            const parent = $(this).closest('.frCategory');
            const wasOpen = parent.hasClass('-open');

            $('.frCategory').removeClass('-open');

            if (!wasOpen) {
                parent.addClass('-open');
                /* Give CSS transitions time to complete */
                setTimeout(function () {
                    parent[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });
                }, 250);
            }
        });

        $('.eventNextStep').on('click', function () {
            $('[data-index=' + $(this).data('next-index') + '] .frCategory__header').trigger('click');
        });

        function maybeDisableQuantityButtons() {
            const $input = $(this);
            const max = $input.attr('max');
            const min = $input.attr('min');
            $input.parent().find('.festival-qty-btn').each(function () {
                $(this).toggleClass('disabled', $input.val() === ($(this).data('change') === '+' ? max : min));
            });
        }

        $('.quantity input').each(maybeDisableQuantityButtons);

        $('.festival-qty-btn').on('click', function () {
            const change = $(this).data('change');
            const input = $(this).parent().find('input.qty');

            const max = input.attr('max'),
                min = input.attr('min');

            const curVal = parseInt(input.val());

            if (change === '+') {
                if (curVal < max || max === '') {
                    input.val(curVal + 1);
                }
            } else if (curVal > min || min === '') {
                input.val(curVal - 1);
            }

            maybeDisableQuantityButtons.call(input);

            input.trigger('input');
        });

        $('#opc-messages').on('click', '.woocommerce-message,.woocommerce-error', function () {
            $(this).remove();
        });
    }

    // themes/page-builder-framework/assets/woocommerce/js/woocommerce.js triggers "change" event
    // but one-page-checkout listens for "input" and not "change"
    $('.checkout').on('change', '#order_review .opc_cart_item div.quantity input.qty', function (e) {
        if (!e.originalEvent) {
            $(this).trigger('input');
        }
    });
});
